/* lv-article · reading progress and exposure switcher (2026-10-03)
   Progressive enhancement: without JavaScript the article shows a plain image grid and no bar.
   Motion only with a function: the bar shows reading progress, the switcher swaps one photo.
   Honors prefers-reduced-motion (no transitions are used either way). */
(function () {
  'use strict';

  /* ---------- reading progress ---------- */
  var bar = document.querySelector('[data-lva-progress]');
  var body = document.querySelector('.lva-body');
  if (bar && body) {
    var ticking = false;
    var update = function () {
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight * 0.5;
      var done = Math.min(Math.max(-rect.top + window.innerHeight * 0.25, 0), Math.max(total, 1));
      bar.style.transform = 'scaleX(' + (total > 0 ? done / total : 0).toFixed(4) + ')';
      ticking = false;
    };
    var onScroll = function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- exposure switcher ---------- */
  document.querySelectorAll('[data-lv-ladder]').forEach(function (root) {
    var frames = Array.prototype.slice.call(root.querySelectorAll(':scope > figure'));
    if (frames.length < 2) { return; }

    var stage = document.createElement('div');
    stage.className = 'lvl-stage';
    var side = document.createElement('div');
    side.className = 'lvl-side';
    var label = document.createElement('p');
    label.className = 'lv-label';
    label.textContent = 'Exposure level';
    var group = document.createElement('div');
    group.className = 'lvl-btns';
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Exposure level of the profile');
    var hint = document.createElement('p');
    hint.className = 'lvl-hint';
    hint.textContent = root.getAttribute('data-hint') || '';

    /* readout: skin swatches and a one-line note per level, read from the table in the article */
    var rows = {};
    document.querySelectorAll('.lva-body table tbody tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('td');
      if (cells.length < 4) { return; }
      var sw = tr.querySelectorAll('.sw');
      rows[cells[0].textContent.trim()] = {
        light: sw[0] ? sw[0].style.background : '',
        dark: sw[1] ? sw[1].style.background : '',
        note: cells[3].textContent.trim()
      };
    });
    var read = document.createElement('div');
    read.className = 'lvl-read';
    read.setAttribute('aria-live', 'polite');
    var note = document.createElement('p');
    note.className = 'lvl-note';
    var chips = document.createElement('div');
    chips.className = 'lvl-chips';
    var chipLight = document.createElement('b');
    var chipDark = document.createElement('b');
    [chipLight, chipDark].forEach(function (sw, k) {
      var c = document.createElement('span');
      c.className = 'lvl-chip';
      sw.className = 'lvl-swatch';
      var t = document.createElement('i');
      t.textContent = k === 0 ? 'Light skin' : 'Dark skin';
      c.appendChild(sw);
      c.appendChild(t);
      chips.appendChild(c);
    });
    read.appendChild(note);
    read.appendChild(chips);

    var buttons = [];
    var start = 0;
    frames.forEach(function (fig, i) {
      stage.appendChild(fig);
      fig.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
      var ev = fig.getAttribute('data-ev') || String(i);
      if (fig.hasAttribute('data-start')) { start = i; }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lvl-btn';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.tabIndex = -1;
      b.textContent = ev;
      b.addEventListener('click', function () { select(i, false); });
      group.appendChild(b);
      buttons.push(b);
    });

    function select(i, focus) {
      frames.forEach(function (fig, k) { fig.hidden = k !== i; });
      buttons.forEach(function (b, k) {
        var on = k === i;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        b.classList.toggle('is-on', on);
        if (on && focus) { b.focus(); }
      });
      root.setAttribute('data-current', String(i));
      var d = rows[frames[i].getAttribute('data-ev') || ''];
      if (d) {
        note.textContent = d.note;
        chipLight.style.background = d.light;
        chipDark.style.background = d.dark;
        read.hidden = false;
      } else {
        read.hidden = true;
      }
    }

    group.addEventListener('keydown', function (e) {
      var cur = parseInt(root.getAttribute('data-current'), 10) || 0;
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = Math.min(cur + 1, frames.length - 1); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = Math.max(cur - 1, 0); }
      if (e.key === 'Home') { next = 0; }
      if (e.key === 'End') { next = frames.length - 1; }
      if (next !== null) { e.preventDefault(); select(next, true); }
    });

    side.appendChild(label);
    side.appendChild(group);
    side.appendChild(read);
    if (hint.textContent) { side.appendChild(hint); }
    root.appendChild(stage);
    root.appendChild(side);
    root.classList.add('is-live');
    select(start, false);
  });
})();
